import classNames from 'classnames';
import * as React from 'react';
import css from './ExploreSearchField.module.scss';

interface Props extends React.HTMLProps<{}> {
  isActive: boolean;
  isDisabled: boolean;
  hasPlaceholder: boolean;
  placeholder: string;
  activate: (flag: boolean) => void;
  panel: React.ReactNode;
  handleInput: (query: string) => void;
}

class ExploreSearchField extends React.PureComponent<Props> {
  public static defaultProps: Props = {
    isActive: false,
    isDisabled: false,
    hasPlaceholder: true,
    placeholder: '',
    activate: (_: boolean) => null,
    panel: <div />,
    handleInput: (_: string) => undefined,
  };

  constructor(props: Props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleInput = this.handleInput.bind(this);
  }

  private handleClick(flag: boolean) {
    this.props.activate(flag);
  }

  private handleInput(q: string) {
    this.props.handleInput(q);
  }

  public render() {
    const { placeholder, hasPlaceholder, isActive, isDisabled } = this.props;

    const classes = classNames(css.ExploreSearchField, {
      [css.isActive]: isActive,
      [css.isDisabled]: isDisabled,
    });

    return (
      <div className={classes}>
        {this.props.isActive && (
          <div
            className={css.ExploreSearchField__HiddenLayer}
            onClick={() => this.handleClick(false)}
          />
        )}
        <input
          className={css.ExploreSearchField__Input}
          placeholder={hasPlaceholder ? placeholder : ''}
          disabled={isDisabled}
          onClick={() => this.handleClick(!this.props.isActive)}
          onInput={e => {
            this.handleInput(e.currentTarget.value);
          }}
        />
        <a
          className={css.ExploreSearchField__Link}
          onClick={() => {
            if (isDisabled) {
              return;
            }
            this.handleClick(!this.props.isActive);
          }}
        >
          {hasPlaceholder ? placeholder : ''}
        </a>

        {isActive && this.props.panel}

        {this.props.children && (
          <div className={css.ExploreSearchField__InputValue}>
            {this.props.children}
          </div>
        )}
      </div>
    );
  }
}

export default ExploreSearchField;
